import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURLMapping = {
  drmBidTableData: URLS.DRM_BID_TABLE_DATA_UPDATE,
  drmDailyTableData: URLS.DRM_DAILY_CREATE
};
export const drmCreateTableData = async ([
  createdTableDataList,
  tableName,
  controller,
]) => {
  const response = await axios.post(
    `${tableURLMapping[tableName]}`,
    createdTableDataList,
    { signal: controller.signal }
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
